<template>
    <div class="modal fade" id="need-help-playbook-modal" tabindex="-1" aria-labelledby="need-help-playbook-modal-label" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header border-0 pb-0">
                    <h2 class="modal-title fw-bold text-dark mb-0 mx-2">Build a Smart Play</h2>
                    <button type="button" class="btn btn-white float-end close-modal" data-bs-dismiss="modal" @click.prevent="closeModal" data-bs-toggle="tooltip" title="Close">
                        <img class="icon" src="/img/icons/avid-icons/close.svg" alt="">
                    </button>
                </div>
                <div class="modal-body px-4 pb-0">
                    <p class="text-muted mb-3">Avid simply needs to know a bit about your campaign and we can find the best play for you to run. We'll also customize it to meet your needs. Feel free to provide a few sentences or even a link for Avid to reference.</p>
                    <textarea
                        v-model="campaignDescription"
                        class="form-control mb-2"
                        :class="{ 'is-invalid': errors.campaign_description }"
                        rows="4"
                        placeholder="What is the goal of the campaign? Who is the target audience? Are there certain channels you want to utilize?"
                    />
                    <div v-if="errors.campaign_description" class="invalid-feedback d-block mb-2">{{ errors.campaign_description }}</div>
                </div>
                <div class="modal-footer px-4 pb-4">
                    <button type="button" class="btn btn-secondary rounded-pill px-4 py-2" @click="closeModal">Cancel</button>
                    <button type="button" class="btn btn-primary rounded-pill px-4 py-2" :disabled="submitting || !campaignDescription?.trim()" @click="submit">
                        <span v-if="submitting" class="spinner-border spinner-border-sm me-2" role="status"></span>
                        Next
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { useNotifications } from '../../composables/useNotifications';
import { useClientStore } from '../../stores/client';

export default defineComponent({
    name: 'NeedHelpPlaybookModal',
    props: {
        show: { type: Boolean, default: false },
        initialDescription: { type: String, default: '' },
    },
    emits: ['update:show', 'submitted'],
    setup() {
        const clientStore = useClientStore();
        return { clientStore };
    },
    data() {
        return {
            campaignDescription: '',
            submitting: false,
            errors: {},
        };
    },
    watch: {
        show(val) {
            if (val) {
                this.campaignDescription = this.initialDescription || '';
                this.errors = {};
            }
        },
        initialDescription(val) {
            if (this.show && val) this.campaignDescription = val;
        },
    },
    methods: {
        closeModal() {
            this.$emit('update:show', false);
            const el = document.getElementById('need-help-playbook-modal');
            if (el && window.bootstrap) {
                const modal = window.bootstrap.Modal.getInstance(el);
                if (modal) modal.hide();
            }
        },
        async submit() {
            this.errors = {};
            const desc = (this.campaignDescription || '').trim();
            if (!desc) {
                this.errors.campaign_description = 'Please describe your campaign.';
                return;
            }
            this.submitting = true;
            try {
                const client = this.clientStore.getClient;
                if (!client?.url) {
                    this.errors.campaign_description = 'Client not available.';
                    return;
                }
                const res = await fetch(`/api/playbooks/${client.url}/suggest`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '' },
                    body: JSON.stringify({ campaign_description: desc }),
                });
                const data = await res.json().catch(() => ({}));
                if (res.status === 202 && data.playbook_suggestion_id) {
                    const { showNotification } = useNotifications();
                    const notificationId = showNotification({
                        icon: '/img/icons/nav-icons/Playbooks.svg',
                        text: 'We\'re searching for the perfect play and customizing it to meet your needs.',
                        noDismiss: true,
                    });
                    this.$emit('submitted', { playbook_suggestion_id: data.playbook_suggestion_id, notificationId: notificationId ?? undefined });
                    this.closeModal();
                } else {
                    this.errors.campaign_description = data.message || data.error || 'Something went wrong. Please try again.';
                }
            } catch (e) {
                this.errors.campaign_description = 'Something went wrong. Please try again.';
            } finally {
                this.submitting = false;
            }
        },
    },
});
</script>
